// src/utils/firebase/callRouteCore.js
//
// The routing decision for every web callable (Phase 98 §7.3, docs/features/PHASE98_CLOUD_RUN_SERVICE_BUDGET_FEATURE.md),
// with no imports, so a plain Node test loads it as it is. functionsWithRoutes.js wires it to the Firebase SDK.
//
// A callable whose name is a route of a router (src/generated/functionRoutes.json) ALWAYS goes to that router; a name no
// router serves is the SDK's own httpsCallable, untouched. Until 2026-11-03 each S2 router had a frontend flag and a call
// made while the flags were not loaded yet (the walkie's TURN credentials at boot) went to the legacy function, so the
// legacy functions kept real traffic through the soak and could not be deleted. The soak is over: the iOS app and AI
// Ops route the same way, with no flag (§15, "Routers always routed").

/** { routeName: router } from the route map's { routers: { router: { routes } } } */
export function routerIndex(routeMap) {
  const out = Object.create(null)
  for (const [router, r] of Object.entries((routeMap && routeMap.routers) || {})) {
    for (const name of r.routes || []) out[name] = router
  }
  return out
}

/** URL of a route: https://<region>-<project>.cloudfunctions.net/<router>/<name> */
export function routeUrl(fns, router, name) {
  const projectId =
    (fns && fns.app && fns.app.options && fns.app.options.projectId) || 'gse-main-site'
  const region = (fns && fns.region) || 'us-central1'
  return `https://${region}-${projectId}.cloudfunctions.net/${router}/${name}`
}

/**
 * The route-aware httpsCallable. `sdk`: { httpsCallable, httpsCallableFromURL } (the real SDK); `routers`: routerIndex
 * of the route map. → (fns, name, options) → a callable.
 */
export function makeRouteCallable({ sdk, routers }) {
  return function routeCallable(fns, name, options) {
    const router =
      typeof name === 'string' && Object.prototype.hasOwnProperty.call(routers, name)
        ? routers[name]
        : null
    if (!router) return sdk.httpsCallable(fns, name, options)
    return sdk.httpsCallableFromURL(fns, routeUrl(fns, router, name), options)
  }
}
